import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PersonIcon from '@mui/icons-material/Person';
import CallIcon from '@mui/icons-material/Call';
import { Post } from '../../services/http';
import UserIcon from '../../images/design_useroutlined.png';
import TelIcon from '../../images/tel.png';
import EmailIcon from '../../images/email.png';

export default function AboutUsPage() {
    const [campaigns, setCampaigns] = React.useState(false);
    const openInfoPopup = useStoreActions((actions) => actions.open);

    const send = async () => {
        const fromName = document.getElementById('fromName').value;
        const fromEmail = document.getElementById('fromEmail').value;
        const phone = document.getElementById('phone').value;
        const content = document.getElementById('content').value;
        console.log('fromName', fromName);
        const result = await Post('/api/donation/CreateContactUsItem', { fromName, fromEmail, phone, content });
        console.log('result', result);
        if (result.result) {
            openInfoPopup({ notice: 'הפניה נשלחה בהצלחה', reload: false });
        } else {
            openInfoPopup({ notice: result.message, reload: false });
        }
    };

    return (
        <main className="main bg-color" style={{ paddingBottom: '10px' }}>
            <section className="head-section" style={{ backgroundImage: 'url(/img/backgroundImage.png)' }}>
                <h1 style={{ marginTop: '50px' }} className="head-section__title _anim-items _anim-no-hide _fadeDown rubik f-normal weight-600 f-54 color-2" data-animate-delay="02">
                    About Us
                    <p className="mb-0 f-16 rubik weight-600 text-white  f-normal">
                        Main {'>>'} <span className="color-3">Why Us</span>
                    </p>
                </h1>
                <p className="w-656 mt-20 robto f-normal weight-400 f-16 head-section__text _anim-items _anim-no-hide _fadeDown" data-animate-delay="04">‘World Of Tzedaka’, formerly ’Tomchei Tzedaka Corp’, changed its name as per the guidance of Lakewood’s Posek, Rabbi Yaakov Forchheimer shlit”a, to avoid confusion with similarly-named organizations. <br /> <br />We welcome you to our new website, which is still under construction. Bear with </p>
            </section>

            <div className="container about-page-margin">
                <div className="about">
                    <p className="color-1 center-text roboto f-normal weight-500 f-32 _anim-items _anim-no-hide  _fadeScale" data-animate-delay="06"><span>Connecting givers and receivers</span></p>

                    <div className="about__content">
                        <p className="roboto f-normal weight-400 f-16 center-text color-4 _anim-items _fadeUp" data-animate-delay="01">‘World Of Tzedaka’ is a non-profit 501(c)(3) organization founded a few years ago, with a mission of changing the world of Tzedaka, making Tzedaka-related tasks smoother and easier.</p>

                        <p className="center-text roboto f-normal f-16 color-4 _anim-items _fadeUp" data-animate-delay="03">
                            <span className="weight-500 color-5">One of our goals is to enable any individual or organization to raise money for their specific cause.</span><br />
                            We help individuals from Eretz Yisroel coming to the United States to raise money for themselves or someone else, families in Eretz Yisrael and the United States going through a tragedy, and organizations/Yeshivas around the world. <br />
                            <span className="weight-500 color-5">We offer all the necessary resources and services</span> <span style={{ color: 'grey' }}>needed to fundraise for any cause efficiently and successfully.</span> </p>

                        <p className="center-text roboto weight-400 f-normal f-16 color-4 _anim-items _fadeUp" data-animate-delay="01">All cases that require verification are verified by the ‘Tomchei Tzedaka of Lakewood’ before we start any process. <br />
                            <span className="weight-600 color-5">Once a case is verified, we will begin working on a campaign plan</span>, including articles, footage, and advertising for the campaign on the applicable digital platforms.</p>

                        <p className="center-text roboto weight-500 f-normal f-16 color-5 _anim-items _fadeUp" data-animate-delay="02"><span className="weight-600 color-5">100% of the donations are given directly to the individual / family / organization!</span> <br />
                            We don’t charge any setup fees or donation percentages! <br />
                            Additionally, the individual / family / organization is not required to pay any upfront campaign and marketing costs! <br />
                            <span className="weight-600 color-1">All campaign expenses will be deducted from the total donations at the end of the campaign.</span></p>

                        <p className="center-text weight-400 f-normal roboto f-16 color-5 _anim-items _fadeUp" data-animate-delay="03">
                            It should be emphasized that the production of our system receives the accompanying guidance and close oversight of the expert and veteran in the Chesed industry, Rabbi Shraga Kotler Shlita, director of Bais Medrash Gevoha of Lakewood, and Rabbi Nosson Shalom Nussbaum, Chairman of the Vaad HaTzedaka of Lakewood, as well as the enthusiastic blessing of many of the directors of institutions throughout the country who see it as a real ray of light regarding the fundraising efforts throughout the United States and the support of the leaders of the Jewish world in the charities in the United States.
                        </p>
                        <p className="center-text weight-400 f-normal roboto f-16 color-5 _anim-items _fadeUp" data-animate-delay="02">Unfortunately, the number of Tzedaka causes is increasing. We are here to help with A-Z service, resources, and guidance.</p>
                    </div>
                </div>
            </div>

            <section className="send section">
                <div className="container">
                    <div className="section__head">
                        <p style={{ marginBottom: '20px' }} className="color-1 center-text weight-500 rubik f-normal f-28 _anim-items  _fadeScale" data-animate-delay="02">Send Us A Message</p>
                    </div>

                    <div className="send-form _anim-items  _fadeUp" data-animate-delay="04">
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={UserIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="fromName" placeholder="First Name" />
                            </div>
                        </div>
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={EmailIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="fromEmail" placeholder="E-mail" />
                            </div>
                        </div>
                        <div className="send-form__item">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                            <img src={TelIcon} alt="" />
                                <input type="text" className="border-none input color-4 weight-400 f-16 roboto f-normal" id="phone" placeholder="Tel:" />
                            </div>
                        </div>
                        <div className="send-form__message">
                            <div className="flex align-center bg-white" style={{ padding: 15, borderRadius: '10px' }}>
                                <textarea className="border-none input color-4 weight-400 f-16 roboto f-normal" id="content" placeholder="Message:"></textarea>
                            </div>
                        </div>
                        <div className="send-form__button">
                            <button style={{ marginBottom: '30px', background: '#1979BE', width: '100%' }} type="submit" className="btn-red" onClick={send}>Send</button>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
